import Layout from "../components/layout/Layout";

export default function AdminDashboard(){

  return (
    <Layout role="admin">
      <h1>Admin Dashboard</h1>
    </Layout>
  );
}